import React from "react";
import styled from "styled-components/macro";

const JunoHint = styled.span`
  display: block;
  color: var(--juno-color-text-secondary);
  font-family: var(--juno-font-family-body);
  font-weight: var(--juno-font-weight-light);
`;

function Hint(props) {
  return <JunoHint>{props.children}</JunoHint>;
}

export default Hint;
